import { LayoutProps } from "../../../../../types";
import { AccessList } from "../../types";

export enum AccessListVariant {
  None = 0,
  Big,
  Small,
}

export interface AccessListProps extends LayoutProps {
  accessList: AccessList;
  updateAccessList?: (fn: (prev: AccessList) => AccessList) => void;
  readOnly?: boolean;
  variant?: AccessListVariant;
  title?: string;
}
